export function getLanguageCodeFromLocale(locale: string): string {
  if (locale === 'en-GB') return 'en';
  return locale;
}
